import { createSelector } from "@ngrx/store";
import { IRootState } from "../../../store";
import { ActionTypes, TypeAction } from "./drug-check.actions";

export interface IState {
  status: any;
  message: string | null;
  startedAt: Date | null;
}

const initialState: IState = {
  status: null,
  message: null,
  startedAt: null,
};

export function drugCheckReducer(state: IState = initialState, action: TypeAction): IState {
  const { type, payload } = action;

  switch (type) {
    case ActionTypes.STORE_DRUG_CHECK_STATUS: {
      return Object.assign({}, state, payload);
    }

    default: {
      return state;
    }
  }
}

export const getDrugCheckStatusNumber = createSelector(
  (root: IRootState): IState => root.drugCheck,
  ({ status }: IState): number => status
);